export enum VariableScope {
	ClientVariable = 'ClientVariable',
	ProjectVariable = 'ProjectVariable',
	ClientSecret = 'ClientSecret',
	ProjectSecret = 'ProjectSecret',
	PARAM = 'PARAM', //cased like this for backward compatibility, as this is used in the frontend to identify parameter variables
	FlowVariable = 'FlowVariable',
	RecordVariable = 'RecordVariable',
}
